"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Megaphone24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "megaphone-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M21,2 L21,22 L19,22 L19,20.474 L15,19.421 L15,20.4384472 C15,21.5430167 14.1045695,22.4384472 13,22.4384472 C12.8364764,22.4384472 12.67357,22.4183925 12.5149287,22.3787322 L8.51492875,21.3787322 C7.62459475,21.1561487 7,20.3561825 7,19.4384472 L7,17.316 L4.2365201,16.5885579 C2.91858093,16.2417318 2,15.0501446 2,13.6873343 L2,10.3126657 C2,8.94985536 2.91858093,7.75826818 4.2365201,7.41144208 L19,3.526 L19,2 L21,2 Z M9,17.842 L9,19.4384472 L13,20.4384472 L13,18.895 L9,17.842 Z M19,5.59440871 L8,8.488 L8,15.511 L19,18.4055913 L19,5.59440871 Z M6,9.015 L4.7455067,9.34559115 C4.30619364,9.46119985 4,9.85839558 4,10.3126657 L4,13.6873343 C4,14.1416044 4.30619364,14.5388001 4.7455067,14.6544088 L6,14.984 L6,9.015 Z", id: "Combined-Shape", fill: "#000000" })));
}
function Megaphone24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Megaphone24Svg, Object.assign({}, svgProps)));
}
exports.default = Megaphone24;
//# sourceMappingURL=Megaphone24.js.map